import { useOnboarding } from '../context'
import type { Choice, QuestionValues, Role } from '../typings'
import { StepChoice } from './StepChoice'

export interface StepAnswerProps extends Pick<Choice, 'text' | 'value'> {
  surveyKey: QuestionValues['key']
  question: QuestionValues['question']
  icon?: Choice['icon']
  advanceTo?: Role
  onClick?: () => void
  isSelectable?: boolean
}

export const StepAnswer = ({
  isSelectable = true,
  ...props
}: StepAnswerProps) => {
  const onboarding = useOnboarding()
  const isSelected =
    isSelectable &&
    onboarding.state.survey[props.surveyKey]?.value === props.value

  function handleSelection() {
    const survey = onboarding.state.survey
    survey[props.surveyKey] = {
      question: props.question,
      label: props.text,
      value: props.value
    }
    onboarding.updateState({ survey })

    props.onClick?.()

    if (props.advanceTo) {
      onboarding.updateState({ role: props.advanceTo })
      return
    }
  }

  return (
    <StepChoice
      testId={`step-choice-${props.value}`}
      icon={props.icon}
      text={props.text}
      isSelected={isSelected}
      onClick={handleSelection}
    />
  )
}
